/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TrackElement } from './TrackElement';
import {
    TrackElementFromJSON,
    TrackElementFromJSONTyped,
    TrackElementToJSON,
} from './TrackElement';

/**
 * 
 * @export
 * @interface RemixParent
 */
export interface RemixParent {
    /**
     * 
     * @type {Array<TrackElement>}
     * @memberof RemixParent
     */
    tracks?: Array<TrackElement>;
}

/**
 * Check if a given object implements the RemixParent interface.
 */
export function instanceOfRemixParent(value: object): value is RemixParent {
    let isInstance = true;

    return isInstance;
}

export function RemixParentFromJSON(json: any): RemixParent {
    return RemixParentFromJSONTyped(json, false);
}

export function RemixParentFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemixParent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tracks': !exists(json, 'tracks') ? undefined : ((json['tracks'] as Array<any>).map(TrackElementFromJSON)),
    };
}

export function RemixParentToJSON(value?: RemixParent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tracks': value.tracks === undefined ? undefined : ((value.tracks as Array<any>).map(TrackElementToJSON)),
    };
}

